// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bm-0";
export var headerCellHover = "_bm-1";
export var readCellContainer = "_bm-2";
export var readCellSlot = "_bm-3";
export var rowHoverCheckbox = "_bm-4";
export var rowUnreadIndicator = "_bm-5";
export var searchHighlight = "_bm-8";
export var summaryCellHoverWrapper = "_bm-9";
export var supportTicketRow = "_bm-6";
export var unreadIndicator = "_bm-7";